import * as React from "react";

function SvgPingdom(props, ref) {
  return (
    <svg viewBox="0 0 30 24" width="1em" height="1em" {...{ ...props, ref }}>
      <path d="M14.874 19.213l9.898-4.228L16.005 24a17.875 17.875 0 00-1.174-4.902l.042.121zm14.974-8.31a54.969 54.969 0 00-19.153 2.494l.39-.106a18.115 18.115 0 013.105 4.399l.047.104c5.027-2.798 11.996-6.371 15.61-6.879v-.012zm-15.638.342l.257-.075a48.582 48.582 0 005.943-2.186l-.318.126a20.636 20.636 0 005.217-2.978l-.045.034a11.262 11.262 0 003.601-5.048l.024-.079c.139-.299.253-.647.327-1.01l.005-.031C26.704 3.43 16.734 3.79 16.734 3.79l2.351-2.156A32.707 32.707 0 00-.095 7.892L0 7.826c3.93.43 7.413 2.07 10.138 4.533l-.016-.014c1.351-.418 2.736-.716 4.087-1.093v-.007z" />
    </svg>
  );
}

export default React.forwardRef(SvgPingdom);
